module.exports = new __parcel__URL__("education.93832ff9.jpeg").toString();